import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Use HttpBackend so the loader bypasses the interceptor chain.
// Without this, acceptLanguageInterceptor injects LocaleService while
// LocaleService is still constructing — triggering NG0200.
//
// The suffix carries a cache-busting query param (fixed per page load) so the
// browser's HTTP cache can never serve a stale translation file — without it,
// editing en.json/ar.json requires a hard refresh (Ctrl+Shift+R) instead of a
// normal reload to see the change.
export function translateHttpLoaderFactory(handler: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(handler), 'i18n/', `.json?v=${Date.now()}`);
}
